import { Navigate, Outlet } from "react-router-dom";

import { LoadingState } from "~/common/components";
import { isUserVerified } from "~/common/utils";
import { useGetCurrentPatient } from "../hooks/queries/useGetCurrentPatient";
import { ROUTES } from "./routes";

export const VerifiedRoutes = () => {
  const { data: patient } = useGetCurrentPatient();

  if (!patient) return <LoadingState className="h-screen" />;

  return isUserVerified(patient) ? (
    <Outlet />
  ) : (
    <Navigate to={ROUTES.verification} />
  );
};
